<template>
    <div
        class="flex items-center justify-between rounded-lg border px-4 py-3 cursor-pointer"
        :class="selected === value ? 'border-rent-risk-blue-400 bg-blue-50' : 'border-gray-300 bg-white'"
        @click="$emit('update:modelValue', value)"
    >
        <span class="text-sm font-medium text-gray-900">{{ label }}</span>
        <input
            type="radio"
            class="h-4 w-4 text-rent-risk-blue-400 focus:ring-rent-risk-blue-400"
            :name="name"
            :value="value"
            :checked="selected === value"
            @change="$emit('update:modelValue', value)"
        />
    </div>
</template>

<script>
export default {
    props: {
        name: { type: String, required: true },
        label: { type: String, required: true },
        value: { type: [Boolean, String], required: true },
        modelValue: { type: [Boolean, String, null], default: null },
    },
    emits: ['update:modelValue'],
    computed: {
        selected() {
            return this.modelValue;
        },
    },
};
</script>
